import React, { useEffect, useState } from 'react';
import '@/assets/sass/style.scss';
import Swagger from '@/components/Swagger';
import { EnvironmentType } from '@/types/environmentType';
import { SpecUrlsProvider } from '@/context/SpecUrlsContext';

const Main = () => {
  const [environment, setEnvironment] = useState<EnvironmentType | null>(null);

  const fetchEnvironment = async () => {
    const result = await fetch('./environment.json');
    const environment = await result.json();
    setEnvironment(environment);
  };

  useEffect(() => {
    fetchEnvironment();
  }, []);

  return (
    <>
      <SpecUrlsProvider>{environment && <Swagger environment={environment} />}</SpecUrlsProvider>
    </>
  );
};

export default Main;
